import Skeleton from 'primevue/skeleton'

export default {
  __name: 'skeleton',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Skeleton() { return Skeleton } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}